module.exports = __webpack_public_path__ + "img/disanbu.5628217b.png";